import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import SliderCourseListing from "./SliderCourseListing";
import { SessionKeys } from "../../utils/AppUtils";
import { setFavoriteCourses } from "../../redux/courses/actions";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import Slider from "react-slick";
import CourseCardListBody from "../Course/CourseCardListBody";
import { Carousel, Tab, Tabs } from "react-bootstrap";
import LearningPathModal from "./LearningPathModal";
import FilterSection from "./FilterSection";
import { Events, scroller } from "react-scroll";
import ShimmerCardBody from "../Layouts/ShimmerCardBody";
import { setCurrentView } from "../../redux/assignCourse/actions";
import LearningPathCard from "./LearningPathCard";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";

const LearningPathSection = (props) => {
  const { learningPathData, lpUnAssignedData, isLoading, isLoadingUnAssigned } =
    props;

  const dispatch = useDispatch();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const id = params.get("id");
  const explore = params.get("explore");

  const userRole = useSelector((state) => state.user.role);

  const [learningListingData, setLearningListingData] = useState([]);
  const [lpUnAssignListingData, setLpUnAssignListingData] = useState([]);
  const [pageType, setPageType] = useState("course");
  const [closeChildModal, setCloseChildModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showLearningData, setShowLearningData] = useState({});
  const [activeTab, setActiveTab] = useState("assigned");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (explore === "true") {
      setActiveTab("more");
    }
  }, [dispatch]);

  useEffect(() => {
    // console.log(learningPathData)
    if (!_.isEmpty(learningPathData)) {
      const lpData = _.clone(learningPathData);
      // console.log('LP DATA', lpData)
      for (let lp of lpData) {
        if (!_.isArray(lp.coursesList)) {
          for (let course of lp.coursesList) {
            course.is_manager_checklist = lp.is_manager_checklist;
            if (course.durationUnit === "Hours") {
              const convertArray = _.toString(course.duration).includes(":")
                ? course.duration.split(":")
                : [course.duration, 0];
              const hoursMinutes = _.toNumber(convertArray[0]) * 60;
              const minutes = _.toNumber(convertArray[1]);
              const totalMinutes = hoursMinutes + minutes;
              course.duration = totalMinutes;
            }
            if (_.toNumber(course.duration) > 60) {
              let hours = Math.floor(course.duration / 60);
              let minutes = course.duration % 60;
              hours = hours >= 10 ? hours : `0${hours}`;
              minutes = minutes >= 10 ? minutes : `0${minutes}`;
              // console.log(course.duration, hours, minutes)
              // course.duration = `${hours}:${minutes}`
              course.duration = `${hours} ${
                hours > 1 ? "Hours" : "Hour"
              } ${minutes} ${minutes > 1 ? "Mins" : "Min"}`;
              course.durationUnit = "";
            } else if (_.toNumber(course.duration) < 60) {
              // console.log('Minutes')
              course.duration = `${course.duration} ${
                course.duration > 1 ? "Mins" : "Min"
              }`;
              course.durationUnit = "";
            } else {
              // console.log('hour')
              course.duration = "1 Hour";
              course.durationUnit = "";
            }
          }
        }
      }
      setLearningListingData(lpData);
    }
  }, [learningPathData]);

  useEffect(() => {
    // console.log(lpUnAssignedData)
    if (!_.isEmpty(lpUnAssignedData)) {
      const lpData = _.clone(lpUnAssignedData);
      console.log("LP DATA UnAssigned", lpData);
      for (let lp of lpData) {
        if (!_.isArray(lp.coursesList)) {
          for (let course of lp.coursesList) {
            course.is_manager_checklist = lp.is_manager_checklist;
            if (course.durationUnit === "Hours") {
              const convertArray = _.toString(course.duration).includes(":")
                ? course.duration.split(":")
                : [course.duration, 0];
              const hoursMinutes = _.toNumber(convertArray[0]) * 60;
              const minutes = _.toNumber(convertArray[1]);
              const totalMinutes = hoursMinutes + minutes;
              course.duration = totalMinutes;
            }
            if (_.toNumber(course.duration) > 60) {
              let hours = Math.floor(course.duration / 60);
              let minutes = course.duration % 60;
              hours = hours >= 10 ? hours : `0${hours}`;
              minutes = minutes >= 10 ? minutes : `0${minutes}`;
              // console.log(course.duration, hours, minutes)
              // course.duration = `${hours}:${minutes}`
              course.duration = `${hours} ${
                hours > 1 ? "Hours" : "Hour"
              } ${minutes} ${minutes > 1 ? "Mins" : "Min"}`;
              course.durationUnit = "";
            } else if (_.toNumber(course.duration) < 60) {
              // console.log('Minutes')
              course.duration = `${course.duration} ${
                course.duration > 1 ? "Mins" : "Min"
              }`;
              course.durationUnit = "";
            } else {
              // console.log('hour')
              course.duration = "1 Hour";
              course.durationUnit = "";
            }
          }
        }
      }
      setLpUnAssignListingData(lpData);
    }
  }, [lpUnAssignedData]);

  useEffect(() => {
    // console.log('learning listing data', learningListingData)
    scroller.scrollTo("learning-" + id, {
      duration: 100,
      delay: 10,
      smooth: "easeInOutQuart",
    });
  }, [learningListingData]);

  const setFavorite = (id) => {
    // console.log('setFAV_ID', id)
    // return;
    const postData = {
      course_id: {
        _id: {
          $oid: id,
        },
        bkmrk: true,
        type: pageType,
      },
    };
    // dispatch(setFavoriteCourses({
    //     module: 'courseFavorite',
    //     token: localStorage.getItem(SessionKeys.API_TOKEN),
    //     postData
    // }));
  };

  const hideInfoModal = () => {
    setShowInfoModal(false);
    setShowLearningData({});
    // console.log('hide modal')
  };

  const showProgessNaming = (progress) => {
    if (_.toNumber(progress) === 0) {
      return "Not Started";
    } else if (_.toNumber(progress) === 100) {
      return "Completed";
    } else {
      return "In Progress";
    }
  };

  const settings = {
    dots: true,
  };

  return (
    <>
      <section className="my-credit-points learningpaths">
        <div className="rows">
          <div className="mb-5 profile-left-sec ">
            <div className="search_heading mt-5 container">
              {/* <img src="images/learning_img.png" width="109" height="106" alt="" /> */}
              <p className="lable-heading_search">Learning Paths</p>
            </div>
            {/* <div className="container">
              <FilterSection
                learningListingData={learningListingData}
                setLearningListingData={setLearningListingData}
                learningPathData={learningPathData}
              />
            </div> */}
            <div className="mt-5">
              <div className="rows my_learningpath_tab">
                <Tabs
                  onSelect={(k) => setActiveTab(k)}
                  activeKey={activeTab}
                  defaultActiveKey="assigned"
                  className="container"
                >
                  <Tab eventKey="assigned" title="Assigned">
                    {isLoading ? (
                      <>
                        <div className="container mt-5 mb-5">
                          <div className="row">
                            {[1, 2, 3, 4].map((i) => {
                              return <ShimmerCardBody key={`shimmer-${i}`} />;
                            })}
                          </div>
                        </div>
                      </>
                    ) : learningListingData.length > 0 ? (
                      learningListingData.map((learning, index) => {
                        return (
                          <LearningPathCard
                            learning={learning}
                            index={index}
                            isMobile={false}
                            learningListingData={lpUnAssignListingData}
                          />
                        );
                      })
                    ) : (
                      <div className="container mt-5 h-60">
                        <div className="not-found">
                          <div className="interboxes">
                          <NotFoundImage width={200} height={219} />
                            <p>
                              Learning Paths that are assigned to you, will
                              appear here. <br />
                              Click{" "}
                              <a
                                className="hyperlink-to"
                                onClick={() => {
                                  setActiveTab("more");
                                }}
                              >
                                here
                              </a>{" "}
                              to explore Learning Paths.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab>
                  <Tab eventKey="more" title="Explore More">
                    {isLoadingUnAssigned ? (
                      <>
                        <div className="container mt-5 mb-5">
                          <div className="row">
                            {[1, 2, 3, 4].map((i) => {
                              return <ShimmerCardBody key={`shimmer-${i}`} />;
                            })}
                          </div>
                        </div>
                      </>
                    ) : lpUnAssignListingData.length > 0 ? (
                      lpUnAssignListingData.map((learning, index) => {
                        return (
                          <LearningPathCard
                            learning={learning}
                            index={index}
                            isMobile={false}
                            learningListingData={lpUnAssignListingData}
                          />
                        );
                      })
                    ) : (
                      <div className="container mt-5 h-60">
                        <div className="not-found">
                          <div className="interboxes">
                          <NotFoundImage width={200} height={219} />
                            <p>
                              Please contact your Manager to assign a learning
                              path.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <LearningPathModal
        show={showInfoModal}
        onHide={() => hideInfoModal()}
        learningData={showLearningData}
      />
    </>
  );
};

export default LearningPathSection;
